import { tv } from 'tailwind-variants';

export const carouselVariants = tv({
  variants: {
    intent: {
      default: 'w-full',
      testimonial: 'max-w-1172',
    },
  },
});
